export const errorMessages = {
    noBusinessEmailError: 'Please use a business email or contact us at support@sayanchor.com',
    generalSignupError: 'Failed to sign up, please try again',
    generalLoginError: 'Failed to log in, please try again',
    generalMagicLinkError: 'Failed to request a link, please try again'
};
